import React, { useState, useEffect } from 'react';
import { AnchorWithLink } from 'atoms/Anchor';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

const ViewMenuLink = props => {
  const { redirectLink } = props;
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const showThreshold = 100;

  useEffect(() => {
    const onScroll = () => {
      let crntPos = document.documentElement.scrollTop;
      if (crntPos < showThreshold) {
        // downscroll code
        setScrolling(false);
      } else {
        // upscroll code
        setScrolling(true);
      }
      setScrollTop(crntPos <= 0 ? 0 : crntPos);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollTop]);

  const ViewMenuText = () => {
    let view = translateWithI18Next('view');
    let menu = translateWithI18Next('menuTitle');
    return `${view} ${menu}`;
  };

  return (
    <AnchorWithLink
      href={redirectLink}
      className={`${scrolling ? 'floating view_menu_link' : 'view_menu_link'}`}
      spy={true}
      data-testid='viewMenu-test-id'
    >
      <span className='grid-icon grid-icon--line2'>
        <span class='layer layer--primary'>
          <span></span>
          <span></span>
        </span>
        <span class='layer layer--secondary'>
          <span></span>
          <span></span>
        </span>
      </span>
      <label className='view_menu'>{ViewMenuText()}</label>
    </AnchorWithLink>
  );
};

export default ViewMenuLink;
